'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$25() {
  this.bh4 = null;
  this.bh2 = null;
  this.bh3 = false;
  this.bh0 = null;
  this.bh1 = false;
  this.bh5 = false;
  this.bh6 = false;
  this.bh4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$25 as $c_Lpresto_PrestoRouter$$anon$25 };
$p = $c_Lpresto_PrestoRouter$$anon$25.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$25;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$25() {
}
export { $h_Lpresto_PrestoRouter$$anon$25 as $h_Lpresto_PrestoRouter$$anon$25 };
$h_Lpresto_PrestoRouter$$anon$25.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bh4;
});
$p.t = (function() {
  if ((!this.bh3)) {
    this.bh2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bh3 = true;
  }
  return this.bh2;
});
$p.ag = (function() {
  if ((!this.bh1)) {
    this.bh0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bh1 = true;
  }
  return this.bh0;
});
$p.v = (function() {
  if ((!this.bh6)) {
    this.bh5 = false;
    this.bh6 = true;
  }
  return this.bh5;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$25 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$25, "presto.PrestoRouter$$anon$25", ({
  NY: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$25 as $d_Lpresto_PrestoRouter$$anon$25 };
//# sourceMappingURL=presto.-Presto-Router$$anon$25.js.map
